// Create an array containing a range of numbers (including end)
function range(start, end, step = 1) {
    const len = Math.floor((end - start) / step) + 1
    return Array(len).fill().map((_, idx) => start + (idx * step))
}
// Create an array containing multiple instances of the same value  
function repeat(value, count) {
    const len = count < 1 ? 1 : Math.floor(count);
    // eslint-disable-next-line no-unused-vars
    return Array(len).fill().map((_, idx) => value)
}
function formatNumber(number, decPlaces = 2) {
    return parseFloat(Math.round(number * 100) / 100).toFixed(decPlaces);
}
function sum(a) {
    let total = 0
    a.forEach(i => total += i)
    return total;
}
function formatDate(dt) {
    let dd = dt.getDate();
    let mm = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][dt.getMonth()]
    let yy = dt.getFullYear();
    return `${dd}-${mm}-${yy}`
}
export { range, repeat, formatNumber, sum, formatDate };
